import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Span from '../../common/elements/Span';

export default class AtMentionUsersList extends Component {
  render() {
    const {users, styles} = this.props;
    return(
      <div className="AddCommentForm_Suggestions">
        <ul style={styles}>
          {users.map((user) => (
            <li key={user.value}>
              <img src={user.icon} key={user.icon}/>
              <Span title={user.label} key={user.label}>{user.label}</Span>
            </li>
          ))}
        </ul>
      </div>
    );
  }
}

AtMentionUsersList.propTypes = {
  users: PropTypes.array.isRequired,
  styles: PropTypes.object
};